import {SchemeLink} from '../../../applink/SchemeLink';
import {LOG_SERIES_CLICK} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {BADGE_TYPE_TO_ICON_TYPE_MAP} from '../../atoms/Icon/constants';
import {Icon} from '../../atoms/Icon/Icon';
import {SeparatorType} from '../../atoms/Separator/SeparatorType.enum';
import {Text} from '../../atoms/Text/Text';
import {LabelBadge} from '../../molecules/LabelBadge/LabelBadge';
import {LabelBadge16Type} from '../../molecules/LabelBadge/LabelBadge16Type.enum';
import {LabelBadgeSizeType} from '../../molecules/LabelBadge/LabelBadgeSizeType.enum';
import {ThumbnailType} from '../../molecules/ThumbnailWithBadges/ThumbnailType.enum';
import {ThumbnailWithBadges} from '../../molecules/ThumbnailWithBadges/ThumbnailWithBadges';
import {Metadata} from '../Metadata/Metadata';
import {RankingListViewItemProps} from './RankingListViewItemProps.interface';

export function RankingListViewItem({
  title,
  thumbnail,
  badgeList,
  ageGradeBadge,
  statusBadge,
  statusLabelText,
  metaList,
  rank,
  scheme,
  isAgeRestricted,
  imageLazyLoad,
  eventLog,
}: RankingListViewItemProps) {
  return (
    <SchemeLink scheme={scheme || undefined}>
      <div
        className="flex items-center py-5pxr px-15pxr"
        onClickCapture={LOG_SERIES_CLICK}
        {...putTiaraObjectProps(eventLog)}
      >
        <ThumbnailWithBadges
          thumbnailType={ThumbnailType.Portrait}
          thumbnail={thumbnail}
          badgeList={badgeList}
          ageGradeBadge={ageGradeBadge}
          isAgeRestricted={isAgeRestricted}
          imageLazyLoad={imageLazyLoad}
          className="mr-16pxr w-80pxr shrink-0"
        />
        <div className="flex flex-1 flex-col">
          <Text className="font-large3-bold mb-6pxr text-theme-solid-100">
            {rank || ''}
          </Text>
          <Text className="font-medium2 mb-2pxr text-theme-solid-100 line-clamp-2">
            {statusBadge && (
              <Icon
                className="mr-4pxr inline-block align-middle"
                type={BADGE_TYPE_TO_ICON_TYPE_MAP[statusBadge]}
                disableActiveEffect
              />
            )}
            {statusLabelText && (
              <LabelBadge
                className="mr-4pxr inline-flex align-middle"
                sizeType={LabelBadgeSizeType.Size16}
                type={LabelBadge16Type.red}
                label={statusLabelText}
              />
            )}
            {title}
          </Text>
          <Metadata
            texts={metaList}
            separatorType={SeparatorType.Dot}
            subtitleClassName="text-theme-solid-60 opacity-100"
            separatorClassName="text-theme-solid-60"
          />
        </div>
      </div>
    </SchemeLink>
  );
}
